export const makergetres = () => {
    return {
        statusCode: 'SPG-0000',
        errorMessage: null,
        getMakerCheckerResponseList: [
            {
                "makerRequestId": 4301,
                "idempotencyId": "87947",
                "status": "PENDING_APPROVAL",
                "makerId": "sneha.jaiswal+200@freecharge.com",
                "request": null,
                "createdAt": 1741076002000,
                "eventType": "MLE_ONBOARDING",
                "remarks": null,
                "checkerRemarks": [],
                "message": "{\"makerId\": \"sneha.jaiswal+200@freecharge.com\", \"formType\": \"mleOnboardingForm\", \"intentId\": \"INT2d4ccb194b\", \"sectionId\": 307504, \"sectionType\": \"businessDetailSection\", \"childEventType\": \"BUSINESS_DETAIL_SECTION\", \"uniqueIdentifier\": \"tesdfghjt@gmail.com\"}",
                "userActionStatus": "NA",
                "approvalLevel": "L1",
                "editedFields": null,
                "childCheckerResponseList": [
                    {
                        "makerRequestId": 4302,
                        "idempotencyId": "307504",
                        "status": "PENDING_APPROVAL",
                        "makerId": "sneha.jaiswal+200@freecharge.com",
                        "request": "{\"emails\": [\"tesdfghjt@gmail.com\"], \"address\": {\"state\": \"DELHI\", \"pinCode\": \"110059\", \"district\": \"DELHI\", \"addressLine\": \"fdtdyd hdeyeue\"}, \"appLink\": \"https://spg-qa.fcinternal.in/mle-onboarding/create/businessDetails\", \"brandName\": \"juti\", \"gstNumber\": [\"07AXNPS2456B2Z9\"], \"legalName\": \"CHAITHRA RAVIPRASAD\", \"entityType\": \"MLE\", \"kycDocUrls\": {\"GST\": [\"/uploadFetchOcrFile/merchant/mleOnboarding/834722bc-17f9-4545-a52d-4a72b8be1252/gstttt.png\"], \"SHOP_PICS\": [\"/kycDocFile/draftmerchant/null/qr-code (4).png\"], \"BO_ADDRESS\": [\"/kycDocFile/draftmerchant/null/qr-code (4).png\"], \"AUTHORISED_SIGNATORY_SELFIE\": [\"/kycDocFile/draftmerchant/null/qr-code (8).png\"]}, \"panDetails\": {\"dob\": \"1995/12/30\", \"url\": \"/uploadFetchOcrFile/merchant/mleOnboarding/a7e4bf89-238b-429f-916d-ce3130a32df9/image (9) (1).png\", \"name\": \"CHAITHRA RAVIPRASAD\", \"panNumber\": \"LRMPR0534D\"}, \"websiteURLs\": [\"https://spg-qa.fcinternal.in/mle-onboarding/create/businessDetails\"], \"businessType\": \"INDIVIDUAL\", \"mobileNumbers\": [\"7890987678\"], \"turnoverAmount\": \"20000\", \"telephoneNumbers\": [\"04557890123\"], \"turnoverCategory\": \"SMALL\", \"dateOfIncorporation\": \"1995/12/30\", \"companyIdentificationNumber\": \"1234567\"}",
                        "createdAt": 1741076002000,
                        "eventType": "BUSINESS_DETAIL_SECTION",
                        "remarks": null,
                        "checkerRemarks": [],
                        "message": "{\"makerId\": \"sneha.jaiswal+200@freecharge.com\", \"formType\": \"mleOnboardingForm\", \"intentId\": \"INT2d4ccb194b\", \"sectionId\": 307504, \"sectionType\": \"businessDetailSection\", \"childEventType\": \"BUSINESS_DETAIL_SECTION\", \"uniqueIdentifier\": \"tesdfghjt@gmail.com\"}",
                        "userActionStatus": "NA",
                        "approvalLevel": "L1",
                        "editedFields": [],
                        "childCheckerResponseList": null
                    }
                ]
            },
            {
                makerRequestId: 3280,
                idempotencyId: '75089',
                status: 'PENDING_APPROVAL',
                makerId: 'pragya.dadhich+1@freecharge.com',
                request: null,
                createdAt: 1736409809000,
                eventType: 'MLE_ONBOARDING',
                remarks: null,
                checkerRemarks: [[]],
                message: null,
                userActionStatus: 'NA',
                childCheckerResponseList: [
                    {
                        makerRequestId: 3281,
                        idempotencyId: '270002',
                        status: 'PENDING_APPROVAL',
                        makerId: 'pragya.dadhich+1@freecharge.com',
                        request:
                            '{"emails": ["huhsu@mail.co"], "address": {"city": "abbbd", "state": "MAHARASHTRA", "pinCode": "411001", "district": "PUNE", "addressLine": "7777"}, "appLink": "iiuiji", "brandName": "abcd", "gstNumber": ["08AAACH7409R1ZZ"], "legalName": "merchanttt", "entityType": "MLE", "kycDocUrls": {"SHOP_PICS": null, "BO_ADDRESS": null, "AUTHORISED_SIGNATORY_SELFIE": null}, "panDetails": {"dob": null, "url": "https://spg-panelorchestrator-qa-s3.s3.ap-south-1.amazonaws.com/%2FuploadFetchOcrFile/merchant/mleOnboarding/8c6be50f-d977-4439-8fbd-7504648822a6/image%20%2812%29.png?X-Amz-Security-Token=IQoJb3JpZ2luX2VjEJ%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCmFwLXNvdXRoLTEiRzBFAiANTAeaQnSjH4qG6H6m0OQnzji%2B044BxBkruxriWRs8hgIhAO2cZzCpMtZIb5hWLzT2GqsKZMDt8xAZR6FYmh5zQXT3Ko0FCIj%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQAxoMMzY0ODcxMDcyMjA1IgzsE8lfaZboE4sY%2BBoq4QT7OYZOVnPNbh5nYJj05wsrO6wdiGNZRpVmyb0kf%2FEFir1%2BhJw%2F8d%2BsffZFeIE1jJnG9yj9MADEXEkZtYBl3H6a1sUAzAqvNfjNO5QY2n1RJWd2CyI4OHT8UxLhJc%2B6vaqcNN3Eg6SjzC718M%2FocO4s4YlqKtxVuRlo10nnJDUGixQ5tOo9DaJAsT6tIOC8dUPJcPLQMPbKixW1tdc3whT3YKXYI0u0ICBxfdecUjOD70Be8c3LcFurFpgnSVOm0PXofDzOpq6izdBBeqVedoNRwG6wizo1rEegtTDVMxsSWVDCuDpauFEJn3FeQUcOpxsJA86TSm5CNH%2FM7wME%2F8MzkVaYNwpeIkD0UDr4OoJspzk1vRSsrsJc0kyk0KwrjJmOZuCh8bGtTnRJnQ9dq%2FuJB7ywfD1ORiHFFjjpmuwO9SR20F8e%2F6%2FZVU62o44DeJhLWBKxaohaK9b9eh%2F3iZPxsBhvFeCICjjCymbBiuTp4Psy2L7YjL110ZptVRCOmG7BYkK5r%2FP9zYsaxsxYaKdmYNkZCguO7bokqsYxp11aZrdsWFxY0QGGjyISxvum81j5NjRLFjL6g0J5BefY%2Fx3%2BsmqPjS%2BzOTYJrvVVINTxaplgP4EDn1UgeJbQiUmTv%2Fpfybj5fCQBc1n6aAMbXVozQKHpHBw3Mz2lXH9tjCJRsSbG3DseqLg743nK3PdFcsFPCrmiMME%2BV5jf7m%2FSiH84FoylQKki6wur9wSJurDVqvCX0vciiPPZFSboN0MRz%2FDWjmZ9C0W5chVwJfg9dOWLGU4mI6OPXigFJ%2BCEOYxodgEwju39uwY6mgF3c4u3f6PSakyIVygfjDtfgts7LQlW5FebwvFYrgKqg86%2BcPE1SqlB04W4%2FvRS2djeSQpSYRS%2FrTFIYaYn7zrb1GrmlN3fIXMTKFcu1pWBWGwe%2BKCuP8Hg5RSBPRNrYdM8SPzXixBpcF8s%2FUL2e1%2FsGQDEUvbsKDgVq5FE4xZv%2BURN%2Ba%2F9LElNfb%2F6SgKq%2BxZnQgCxkWeyuLKX&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20250109T075926Z&X-Amz-SignedHeaders=host&X-Amz-Expires=299&X-Amz-Credential=ASIAVJ5ACXHGTIL37EBA%2F20250109%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Signature=be6c589f6b7261742daa3940b9ac6b0b06640cd08a71e8f05970dfd56e28e9c5", "name": "Rahul Gupta", "panNumber": "ABCDG1234F"}, "websiteURLs": ["https://www.google.com"], "businessType": "INDIVIDUAL", "merchantType": "Online", "mobileNumbers": ["9898989899"], "amlpepResponse": [{"amlPepSource": "", "exceptionFlag": false, "amlMatchStatus": "", "pepMatchStatus": ""}], "turnoverAmount": 666.0, "agreementExpiry": null, "merchantCategory": "Retail", "telephoneNumbers": ["7878"], "turnoverCategory": null, "dateOfIncorporation": "1974-11-23", "companyIdentificationNumber": "456789"}',
                        createdAt: 1736409809000,
                        eventType: 'BUSINESS_DETAIL_SECTION',
                        remarks: null,
                        checkerRemarks: [[]],
                        message: null,
                        userActionStatus: 'NA',
                        childCheckerResponseList: null,
                    },
                ],
            },
            {
                makerRequestId: 3279,
                idempotencyId: 'MERc12bc7ec1a',
                status: 'INITIATED',
                makerId: 'akash.kushwah@freecharge.com',
                request:
                    '{"entityCode": "MERc12bc7ec1a", "isUnifiedMsr": false, "accountDetail": {"status": 1, "bankName": "Punjab National Bank", "ifscCode": "KKBK0000261", "accountType": "SAVING", "accountNumber": "01730015000888923", "accountHolderName": "Aakash Gupta"}, "settlementType": "NET", "isPayableEnable": true, "narrationConfig": {"prefix": null, "suffix": null, "interim": null, "secondInterim": {"interimType": null}}, "refundThreshold": 4000, "settlementParty": "MERCHANT", "fcCommissionType": "MDR", "fundTransferType": "NEFT", "customisedReports": {}, "disbursementCycle": "T1", "instantSettlement": false, "isSettlementEnable": true, "nextSettlementType": "NET", "hierarchyCommission": false, "isAncillaryFeeEnabled": true, "disbursementTriggerSlot": "04", "hierarchyCommissionList": null, "isZeroSettlementEnabled": false, "isSettlementTypeToBeSwitched": null, "settlementTypeApplicableDate": null, "refundWithNegativeBalanceFlag": true}',
                createdAt: 1736407452000,
                eventType: 'SETTLEMENT',
                remarks: null,
                checkerRemarks: [[]],
                message: null,
                userActionStatus: 'NA',
                childCheckerResponseList: null,
            },
            {
                makerRequestId: 3277,
                idempotencyId: '75088',
                status: 'PENDING_APPROVAL',
                makerId: 'shrikant.varshney@freecharge.com',
                request: null,
                createdAt: 1736398731000,
                eventType: 'MLE_ONBOARDING',
                remarks: null,
                checkerRemarks: [[]],
                message: null,
                userActionStatus: 'NA',
                childCheckerResponseList: [
                    {
                        makerRequestId: 3278,
                        idempotencyId: '269999',
                        status: 'PENDING_APPROVAL',
                        makerId: 'shrikant.varshney@freecharge.com',
                        request:
                            '{"emails": ["asas@asddas.com"], "address": {"city": "dssad", "state": "HARYANA", "pinCode": "122004", "district": "GURGAON", "addressLine": "sdadsa"}, "appLink": "asdasd", "brandName": "sdasda", "gstNumber": ["08AAACH7409R1ZZ"], "legalName": "asddsa", "entityType": "MLE", "kycDocUrls": null, "panDetails": {"dob": null, "url": "https://spg-panelorchestrator-qa-s3.s3.ap-south-1.amazonaws.com/%2FuploadFetchOcrFile/merchant/mleOnboarding/9895d9c6-3ab0-416b-925c-1e768e471338/emailIssue.jpg?X-Amz-Security-Token=IQoJb3JpZ2luX2VjEJ3%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCmFwLXNvdXRoLTEiRjBEAiA3HvnhNkhUhYlTPYvaJYGKEmpXaTRYaQTmx2dkJ%2FSzSAIgPCaUioJAYfWnTAL9%2Bw9RyhixI%2FG6%2FRG3L4IVCh9zNtAqjQUIhv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARADGgwzNjQ4NzEwNzIyMDUiDNMuw96suL7zZgPfryrhBHupO3r5l%2BgF3C29Dd9oLdJVaAibF3b9L4VphbZYChBOc2ho5OrRgMZzVkFL%2FMYNSH1b8rQUH9WODH6PZU5t1JNt%2B946rIHIGSAmYqpZ6fWH7CGoecl%2BXNbvTODNT%2BIvpnnJ%2F1b5o%2Bdldm5nF5DKG%2FLurLsU1ZLVuvcaLxGVo5RaFdUzDlC8UfqUuDHAYH6Vt79iM3eC9yoEVjWXjWy08M1ulFMThX0ZSLxopgdw3moBbX4nlcRszu%2BPX5lYJ5thlj306oxRbBjnuZ67%2BQTf4WWSG%2B0UzlnFb%2Fj%2B4y91U6Yg9z1igCeWpd9VfD6gg1YlCC9I0Kqr7w8VfbwQeYh6gCca1cJjsfCdC1O5mfbvCe8gk2QHXWRYf59c6eGIsajGa3MvIeofnXpYehCkQ97q2ejI0larDo7%2F2HSYfmayphMJyygbgqiDs%2BnFn7eA%2Fo7FK3r6Xt3IBqVqegqmbCtD%2FgFvATf%2F3ypw6dcMqP%2F46Mm4L2cZA2NoMLkrFYWqVN%2FkNF0Cg6a6cKysDKZYlEwi7oBHAfHEnMbMwAYVeQnBuQzyOmyEGnjK0eGRkB%2Ft96tIbiaye1dNLtqDESrt86sthno5pJC5uRpo0UONJeXwINmPncRKicVwgcoDdQJic%2B2NRvSC5YIQIE6nd7LBqFJRtLmJN4Jkqp0kOCZpy36V5jny7TfGC%2FQhQ3nyu0%2F5hz%2Be%2BJwW5I%2BrWFXI%2FkbscpQk55%2FttFTN72S17ogVJW%2FnC5TVpl%2FyR%2FLGp%2FeFfE4C73IQ9snmM1rz6rBLBaOZqZIqiBWFz%2F%2B1yCP2RqqPG%2Fz4u%2BCidTDbp%2F27BjqbAc8zyHREWhQImYffzUGTXGArWFz2%2BM53LlRGF6lyvkXVMFLmbFcjDRo3kd4aAATtiSNPMusTX%2BfM6GBDldAlMPGbjjLH%2BulEA2m%2BrcqEg%2BP%2Fh3OGJHmV9K8wUcrsYaTqX%2FRlfeHA0Bpo5k%2B91jrnpVDYf5iSgzphVvBIPLjubByOrj22mOzZlGb25vd2LwFDk4AO1I8Mdm9GgaSB&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20250109T045708Z&X-Amz-SignedHeaders=host&X-Amz-Expires=299&X-Amz-Credential=ASIAVJ5ACXHGU2HV2GQ4%2F20250109%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Signature=85cbb47b7a8031ca60fa3260d82f0bf7e695073a8f8c987ba6882acb4ecf397b", "name": "Rahul Gupta", "panNumber": "ABCDG1234F"}, "websiteURLs": ["http://localhost.com"], "businessType": "INDIVIDUAL", "merchantType": "Online", "mobileNumbers": ["9718556306"], "amlpepResponse": [{"amlPepSource": "", "exceptionFlag": false, "amlMatchStatus": "", "pepMatchStatus": ""}], "turnoverAmount": 122121.0, "agreementExpiry": null, "merchantCategory": "Retail", "telephoneNumbers": ["98798287892"], "turnoverCategory": null, "dateOfIncorporation": "1974-11-12T06:30:00.000Z", "companyIdentificationNumber": "2112212"}',
                        createdAt: 1736398731000,
                        eventType: 'BUSINESS_DETAIL_SECTION',
                        remarks: null,
                        checkerRemarks: [
                            [
                                {
                                    label: 'Details',
                                    key: 'emails',
                                    value: 'radsad^@mmmc.oom',
                                    status: 'Reject',
                                    remarks: 'testddd',
                                },
                                {
                                    label: 'Details',
                                    key: 'CITY',
                                    value: 'delhi',
                                    status: 'Reject',
                                    remarks: '',
                                },
                                {
                                    label: 'Details',
                                    key: 'STATE',
                                    value: 'DELHI',
                                    status: 'Reject',
                                    remarks: '',
                                },
                                {
                                    label: 'Details',
                                    key: 'PINCODE',
                                    value: '110059',
                                    status: 'Reject',
                                    remarks: '',
                                },
                                {
                                    label: 'Details',
                                    key: 'DISTRICT',
                                    value: 'DELHI',
                                    status: 'Reject',
                                    remarks: '',
                                },
                                {
                                    label: 'Details',
                                    key: 'ADDRESSLINE',
                                    value: 'E-28',
                                    status: 'Reject',
                                    remarks: '',
                                },
                                {
                                    label: 'Details',
                                    key: 'APPLINK',
                                    value:
                                        'https://spg-qa.fcinternal.in/mle-onboarding/create/businessDetails',
                                    status: 'Approve',
                                    remarks: '',
                                },
                                {
                                    label: 'Details',
                                    key: 'BRANDNAME',
                                    value: 'TestLegalName',
                                    status: 'Approve',
                                    remarks: '',
                                },
                                {
                                    label: 'Details',
                                    key: 'GSTNUMBER',
                                    value: '09AAAAH0409R1ZZ',
                                    status: 'Approve',
                                    remarks: '',
                                },
                                {
                                    label: 'Details',
                                    key: 'LEGALNAME',
                                    value: 'TestLegalName',
                                    status: 'Approve',
                                    remarks: '',
                                },
                                {
                                    label: 'Details',
                                    key: 'ENTITYTYPE',
                                    value: 'MLE',
                                    status: 'Approve',
                                    remarks: '',
                                },
                                {
                                    label: 'Details',
                                    key: 'KYCDOCURLS',
                                    value: '',
                                    status: 'Approve',
                                    remarks: '',
                                },
                            ],
                        ],
                        message: null,
                        userActionStatus: 'NA',
                        childCheckerResponseList: null,
                    },
                ],
            },
            {
                "makerRequestId": 3754,
                "idempotencyId": "112342323566",
                "status": "PENDING_APPROVAL",
                "makerId": "anurag.yadav@freecharge.com",
                "request": "{\"forms\":[{\"id\":112342323566,\"type\":\"mleOnboardingForm\",\"state\":\"IN_PROGRESS\",\"sections\":[{\"data\":{\"brandName\":\"SampleBrandName\",\"legalName\":\"SampleLegalName 2\"},\"type\":\"businessDetailSection\",\"state\":\"Complete\"}],\"uniqueIdentifier\":\"zomato517@gmail.com\"}]}",
                "createdAt": 1734590210000,
                "eventType": "MLE_UPDATE_BUSINESS_DETAIL",
                "remarks": null,
                "checkerRemarks": [],
                "message": null,
                "userActionStatus": "PENDING",
                "childCheckerResponseList": [
                  {
                    "makerRequestId": 3755,
                    "idempotencyId": "213243133766",
                    "status": "PENDING_APPROVAL",
                    "makerId": "anurag.yadav@freecharge.com",
                    "request": "{\"data\":{\"legalName\":\"Sample Legal Name\",\"brandName\":\"Sample Brand Name\",\"address\":{\"pinCode\":\"123456\",\"state\":\"Sample State\",\"city\":\"Sample City\",\"addressLine\":\"123 Sample Street\",\"district\":\"Sample District\"},\"gstNumber\":[\"09AAACH7409R1ZZ\"],\"entityType\":\"MLE\",\"websiteURLs\":[\"https://www.samplewebsite.com\"],\"emails\":[\"sample@example.com\",\"info@example.com\"],\"mobileNumbers\":[\"1234567890\",\"0987654321\"],\"telephoneNumbers\":[\"0123456789\",\"9876543210\"],\"turnoverAmount\":1000000.00,\"turnoverCategory\":\"SMALL\",\"kycDocUrls\":{\"PROOFOFADDRESS\":[\"https://www.example.com/pan1\"], \"AADHAAR\":[\"https://www.example.com/pan1\",\"https://www.example.com/pan2\"],\"GST\":[\"https://www.example.com/aadhaar1\"]},\"merchantCategory\":\"Retail\",\"merchantType\":\"Online\",\"businessType\":\"E-commerce\",\"panDetails\":{\"panNumber\":\"ABCDE1234H\",\"dob\":\"1980-01-01\",\"name\":\"Sample Name\",\"url\":\"https://www.example.com/pan\"},\"dateOfIncorporation\":\"2020-01-01\",\"companyIdentificationNumber\":\"CIN123456\",\"appLink\":\"https://www.sampleapp.com\"}}",
                    "createdAt": 1734590210000,
                    "eventType": "BUSINESS_DETAIL_SECTION",
                    "remarks": null,
                    "checkerRemarks": [
                        [
                            {
                                "label": "Merchant Legal Name",
                                "key": "legalName",
                                "value": "PRIYANKA KUMARI",
                                "status": "REJECT",
                                "remarks": "Wrong"
                            },
                            {
                                "label": "Brand Name",
                                "key": "brandName",
                                "value": "gucci",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "Constitution Type",
                                "key": "businessType",
                                "value": "INDIVIDUAL",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "PIN Code",
                                "key": "address.pinCode",
                                "value": "272001",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "District",
                                "key": "address.district",
                                "value": "BASTI",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "State",
                                "key": "address.state",
                                "value": "UTTAR PRADESH",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "Address",
                                "key": "address.addressLine",
                                "value": "addr line",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "Company PAN Upload",
                                "key": "panDetails.url",
                                "value": "/uploadFetchOcrFile/merchant/mleOnboarding/a0821b42-921d-4c83-b54b-799d2fe26b4b/sample_pan.png",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "Company PAN Number",
                                "key": "panDetails.panNumber",
                                "value": "KMKPK7209L",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "Company PAN Name",
                                "key": "panDetails.name",
                                "value": "PRIYANKA KUMARI",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "Date Of Incorporation",
                                "key": "dateOfIncorporation",
                                "value": "1995/06/17",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "GST Upload",
                                "key": "kycDocUrls.GST",
                                "value": "/uploadFetchOcrFile/merchant/mleOnboarding/614faa0b-0e6e-48ba-b3f2-a70694903154/gst1.png",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "GST Number",
                                "key": "gstNumber",
                                "value": "07AAACH7409R1ZZ",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "Turnover Category",
                                "key": "turnoverCategory",
                                "value": "SMALL",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "Company Identification Number",
                                "key": "companyIdentificationNumber",
                                "value": "112321",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "Turnover Amount",
                                "key": "turnoverAmount",
                                "value": "100000",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "Email",
                                "key": "emails",
                                "value": "gucci01@gm.com",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "Website URL",
                                "key": "websiteURLs",
                                "value": "https://cjcd.com",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "Telephone Number",
                                "key": "telephoneNumbers",
                                "value": "05551112537",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "Mobile Number",
                                "key": "mobileNumbers",
                                "value": "9876543212",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "App Link",
                                "key": "appLink",
                                "value": "dgeydgy",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "Bo Address",
                                "key": "kycDocUrls.proof_of_address",
                                "value": [
                                    "/kycDocFile/draftmerchant/null/sampleBO1.png"
                                ],
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "Authorised Signatory Selfie",
                                "key": "kycDocUrls.aadhaar",
                                "value": "/kycDocFile/draftmerchant/null/authsignatoryselfie.png",
                                "status": "APPROVE",
                                "remarks": ""
                            }
                        ]
                    ],
                    "message": '{\"makerId\": \"sneha.jaiswal+200@freecharge.com\", \"formType\": \"mleOnboardingForm\", \"intentId\": \"INT2d4ccb194b\", \"sectionId\": 307504, \"sectionType\": \"businessDetailSection\", \"childEventType\": \"BUSINESS_DETAIL_SECTION\", \"uniqueIdentifier\": \"tesdfghjt@gmail.com\"}',
                    "userActionStatus": "PENDING",
                    "editedFields": ["address.state", "address.pinCode", "kycDocUrls"],
                    "childCheckerResponseList": null
                  }
                ]
              },
              {
                "makerRequestId": 3756,
                "idempotencyId": "112342323567",
                "status": "PENDING_APPROVAL",
                "makerId": "anurag.yadav@freecharge.com",
                "request": "{\"forms\":[{\"id\":112342323567,\"type\":\"mleOnboardingForm\",\"state\":\"IN_PROGRESS\",\"sections\":[{\"data\":{\"brandName\":\"SampleBrandName\",\"legalName\":\"SampleLegalName 2\"},\"type\":\"businessDetailSection\",\"state\":\"Complete\"}],\"uniqueIdentifier\":\"zomato518@gmail.com\"}]}",
                "createdAt": 1734590210000,
                "eventType": "MLE_UPDATE_OWNERSHIP_DETAIL",
                "remarks": null,
                "checkerRemarks": [],
                "message": null,
                "userActionStatus": "PENDING",
                "childCheckerResponseList": [
                  {
                    "makerRequestId": 3757,
                    "idempotencyId": "112342323568",
                    "status": "PENDING_APPROVAL",
                    "makerId": "anurag.yadav",
                    "request": "{\"uboDetails\": [{\"name\": \"PRIYANKA KUMARI\", \"email\": \"ubo1@dc.cd\", \"status\": \"ACTIVE\", \"address\": {\"state\": \"UTTAR PRADESH\", \"pinCode\": \"272001\", \"district\": \"BASTI\", \"addressLine\": \"ubo1 add\"}, \"panDetails\": {\"dob\": \"1995/06/17\", \"url\": \"/uploadFetchOcrFile/merchant/mleOnboarding/a3859ca8-2fdc-489b-945b-88484eacda45/sample_ubopan1.png\", \"name\": \"PRIYANKA KUMARI\", \"panNumber\": \"KMKPK7209L\"}, \"addressProof\": \"Pan\", \"addressProofUrls\": [\"/kycDocFile/draftmerchant/null/proofofadressdocument.png\"]}, {\"name\": \"Anurag Kumar\", \"email\": \"test_merch_01@gmail.com\", \"status\": \"ACTIVE\", \"address\": {\"state\": \"Haryana\", \"pinCode\": \"122022\", \"district\": \"Gurgaon\", \"addressLine\": \"dlf phase 2\"}, \"panDetails\": {\"dob\": \"1995/06/17\", \"url\": \"/uploadFetchOcrFile/merchant/mleOnboarding/b5afc6ca-83ce-4496-826d-cf912d187a07/sample_ubopan2.png\", \"name\": \"Anurag Kumar\", \"panNumber\": \"KMKPK7101L\"}, \"addressProof\": \"Aadhaar\", \"addressProofUrls\": [\"/kycDocFile/draftmerchant/null/ubo2proofofadressdocument.png\"]}], \"uboDeclarationUrls\": [\"/kycDocFile/draftmerchant/null/ubodeclaration.pdf\"]}",
                    "createdAt": 1734590210000,
                    "eventType": "OWNERSHIP_DETAIL_SECTION",
                    "remarks": null,
                    "checkerRemarks": [
                        [
                            {
                                "label": "UBO Declaration",
                                "key": "uboDeclarationUrls.0",
                                "value": "/kycDocFile/draftmerchant/null/ubodeclaration.pdf",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO Name",
                                "key": "uboDetails.0.name",
                                "value": "PRIYANKA KUMARI",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO PAN Document",
                                "key": "uboDetails.0.panDetails.url",
                                "value": "/uploadFetchOcrFile/merchant/mleOnboarding/a3859ca8-2fdc-489b-945b-88484eacda45/sample_ubopan1.png",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO PAN Number",
                                "key": "uboDetails.0.panDetails.panNumber",
                                "value": "KMKPK7209L",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO PAN Name",
                                "key": "uboDetails.0.panDetails.name",
                                "value": "PRIYANKA KUMARI",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO Date of Birth",
                                "key": "uboDetails.0.panDetails.dob",
                                "value": "1995/06/17",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "PIN Code",
                                "key": "uboDetails.0.address.pinCode",
                                "value": "272001",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "District",
                                "key": "uboDetails.0.address.district",
                                "value": "BASTI",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "State",
                                "key": "uboDetails.0.address.state",
                                "value": "UTTAR PRADESH",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO Address",
                                "key": "uboDetails.0.address.addressLine",
                                "value": "ubo1 add",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO Email",
                                "key": "uboDetails.0.email",
                                "value": "ubo1@dc.cd",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO Proof Of Address",
                                "key": "uboDetails.0.addressProof",
                                "value": "Pan",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO Proof Of Address Document",
                                "key": "uboDetails.0.addressProofUrls",
                                "value": "/kycDocFile/draftmerchant/null/proofofadressdocument.png",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO Active",
                                "key": "uboDetails.0.status",
                                "value": "ACTIVE",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO Name",
                                "key": "uboDetails.1.name",
                                "value": "Anurag Kumar",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO PAN Document",
                                "key": "uboDetails.1.panDetails.url",
                                "value": "/uploadFetchOcrFile/merchant/mleOnboarding/b5afc6ca-83ce-4496-826d-cf912d187a07/sample_ubopan2.png",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO PAN Number",
                                "key": "uboDetails.1.panDetails.panNumber",
                                "value": "KMKPK7101L",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO PAN Name",
                                "key": "uboDetails.1.panDetails.name",
                                "value": "Anurag Kumar",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO Date of Birth",
                                "key": "uboDetails.1.panDetails.dob",
                                "value": "1995/06/17",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "PIN Code",
                                "key": "uboDetails.1.address.pinCode",
                                "value": "122022",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "District",
                                "key": "uboDetails.1.address.district",
                                "value": "Gurgaon",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "State",
                                "key": "uboDetails.1.address.state",
                                "value": "Haryana",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO Address",
                                "key": "uboDetails.1.address.addressLine",
                                "value": "dlf phase 2",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO Email",
                                "key": "uboDetails.1.email",
                                "value": "test_merch_01@gmail.com",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO Proof Of Address",
                                "key": "uboDetails.1.addressProof",
                                "value": "Aadhaar",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO Proof Of Address Document",
                                "key": "uboDetails.1.addressProofUrls",
                                "value": "/kycDocFile/draftmerchant/null/ubo2proofofadressdocument.png",
                                "status": "APPROVE",
                                "remarks": ""
                            },
                            {
                                "label": "UBO Active",
                                "key": "uboDetails.1.status",
                                "value": "ACTIVE",
                                "status": "APPROVE",
                                "remarks": ""
                            }
                        ]
                    ],
                    "message": '{\"makerId\": \"sneha.jaiswal+200@freecharge.com\", \"formType\": \"mleOnboardingForm\", \"intentId\": \"INT2d4ccb194b\", \"sectionId\": 307504, \"sectionType\": \"businessDetailSection\", \"childEventType\": \"BUSINESS_DETAIL_SECTION\", \"uniqueIdentifier\": \"tesdfghjt@gmail.com\"}',
                    "userActionStatus": "PENDING",
                    "editedFields": ["uboDeclarationUrls.0"],
                    "childCheckerResponseList": null
                  }
                ]
              }
        ],
        pageNumber: 0,
        pageSize: 4,
        hasNext: false,
        totalElements: 4,
    };
};
